import './styles/productPage.scss'

import { state } from './store/state'
import data from './store/data'
import triggers from './store/triggers'
import elements from './store/elements'

import { debounce } from '../../js/debounce'
import price from './components/price'
import imagesStandard from './components/images.standard'
import amounts from './components/amounts'
import addButton from './components/add.button'
import addAjax from './components/add.ajax'
import addModal from './components/add.modal'
import giftCardTerms from './components/giftCard.terms'
import { isNullOrUndef } from '../../utils/isNullOrUndef'
import { isNotNullOrUndef } from '../../utils/isNotNullOrUndef'

const pp = window.productPage

// Get current Variant
// =============================================================================
const getCurrentVariant = debounce(() => {
  const currentOptions = []
  elements.amounts.length > 0 && currentOptions.push(state.amount)

  state.variant = data.variants.find(item => {
    return currentOptions.every(value => item.options.includes(value))
  })

  state.cartDisabled = !state.variant

  if (state.variant) {
    window.history.replaceState(null, '', `${window.location.pathname}?variant=${state.variant.id}`)
  }

  triggers.emitEvent('state:variant', [state.variant])
  triggers.emitEvent('state:cartDisabled', [state.cartDisabled])
}, 150)
triggers.on(['state:amount'], getCurrentVariant)

// Exports to window productPage
// =============================================================================
pp.getData = () => {
  return {
    amount: state.amount,
    product: {
      title: elements.title.textContent
    },
    variant: state.variant
  }
}
pp.setData = (key, value) => {
  state[key] = value
  triggers.emitEvent(`state:${key}`, [value])
}
pp.watcher = {
  amount (callback) { triggers.on('state:amount', callback) },
  variant (callback) { triggers.on('state:variant', callback) }
}

// Subscribe to event 'change'
// =============================================================================
elements.form.addEventListener('change', ({ target }) => {
  const newValue = target.dataset.avalue

  if (state.amount === newValue) return

  state.amount = newValue
  triggers.emitEvent('state:amount', [newValue])
  state.imgIndex = elements.amounts.indexOf(target.parentElement.querySelector('label'))
  triggers.emitEvent('state:imgIndex', [state.imgIndex])
})

// Dispatch event
document.dispatchEvent(new window.CustomEvent('jsProductPageLoaded'))

// set variant
const searchProps = new URLSearchParams(window.location.search)
const variantID = Number(searchProps.get('variant') ?? 0)
state.variant = data.variants.find(item => {
  return item.id === variantID
}) ?? data.variants[0]
state.imgIndex = data.variants.indexOf(state.variant)
state.amount = state.variant.option1

// Components
// =============================================================================
// price
price()
// add to cart button
addButton()
// options
amounts()
// images
imagesStandard()
// ajax logic
addAjax()
// add to cart modal
addModal()
// gift card terms tooltip
giftCardTerms()

// Another logic
// =============================================================================
// Social Share
if (window.innerWidth < 1200) {
  const wrapper = document.querySelector('.product__social-sharing--mob')

  if (isNotNullOrUndef(wrapper)) {
    wrapper.querySelector('button').addEventListener('click', () => {
      wrapper.classList.toggle('active')
    })
  }
}

// EVENTS (GTM)
// =============================================================================
;(() => {
  const oqInterval = setInterval(() => {
    if (window.matchMedia('(min-width: 768px) and (max-width: 1200px)').matches) {
      const oqSection = document.querySelector('.shopify-section.our-quality__section')
      const pdSection = document.querySelector('.shopify-section.product__description_section')
      // console.log('interval')
      if (isNullOrUndef(oqSection) || isNullOrUndef(pdSection)) return

      clearInterval(oqInterval)
      pdSection.append(oqSection)
    }
  }, 100)
})()
